/**
 * Javascript file for searching for technologies.
 * @author Adrian Rebmann, Steffen Schuhmann, Yannik Sprengart
 */

import {
    getDigitalOffers
} from "../../../../api";
import axios from "axios";

// Import config from correct environment
var environment = process.env.NODE_ENV;
var config = require(`../../../../../config/${environment}.json`);


export default {
    name: "OfferSearchMain",

    /**
     * TODO: finish filling these fields.
     * The vue instance's data object.
     * @property {boolean} show -
     * @property {any[]} fullRequest - The full data resulting from the HTTP request.
     * @property {string} input.catKey -
     * @property {string} requestUrl - The URL for the HTTP request.
     * @property {string} imageLink - The base path for the image link.
     * @property {any} placeholderSVG - The placeholder image.
     * @property {any[]} categoriesFromBackend -
     * @property {object} categories - The technology categories.
     * @property {boolean} loading - Information is currently being processed.
     * @property {boolean} firstLoad - Specifies if it is the first time loading the page.
     * @property {any[]} searchresults - The results from the search.
     * @property {string} msg - The platform's name.
     * @property {string} searchterm - The search term.
     * @property {boolean} searchoptions.shouldSort - 
     * @property {number} searchoptions.threshold -
     * @property {number} searchoptions.location -
     * @property {number} searchoptions.distance - 
     * @property {number} searchoptions.maxPatternLength - The maximum length a pattern may have. 
     * @property {number} searchoptions.minMatchCharLength - The minimum amount of characters that have to match between 
     * the search result and the search term for a result to be shown to the user.  
     * @property {string[]} searchoptions.keys - The key values for the search.
     * @property {string} categoryName - The name of the category.
     * @property {string} categoryDescription - The description of the category.
     * @property {string} startpage.describtion - The description of the technology search.

     */
    data: () => ({
        show: false,
        fullRequest: [],
        input: {
            catKey: "get-all",
        },
        //Load Server Config
        //requestUrl: `${config.server}/technology/`,
        imageLink: `${config.deployment}/static/`, //images are not uploaded via the system but manually

        placeholderSVG: require("../../../../assets/tech-placeholder.svg"),
        categoriesFromBackend: [],
        categories: null,
        loading: true,
        firstLoad: true,
        digitaloffers: [],
        alldigitaloffer:[],
        searchresults: [],
        msg: "WERNER",
        searchterm: "",
        searchoptions: {
            shouldSort: true,
            threshold: 0.3,
            location: 0,
            distance: 100,
            maxPatternLength: 32,
            minMatchCharLength: 3,
            keys: ["name", "description"],
        },
        // Left Card
        categoryName: "Allgemein",
        categoryDescription: "",
        //StartPage
        startpage: {
            describtion:
                "Mit der Übersichtsseite für digitale Angebote können Sie schnell und verlässlich eine Auswahl an relevanten digitalen Angeboten für Ihre Bedürfnisse identifizieren. Diese Seite zeigt Ihnen alle verfügbaren digitalen Angebote aus dem Mittelstand-Digital-Netzwerk an. Damit Sie einfach ein passendes Angebot finden, haben wir diese in mehrere Angebotskategorien unterteilt. Durch Eingabe in das Suchfeld können spezifische Angebote gefunden werden. Viel Spaß beim Entdecken!",
        },
    }),

    /**
     * The vue instance's method declaration.
     */
    methods: {
        /**
         * Searches for technologies based on the search term and the search options.
         */
        search() {
            this.$search(this.searchterm, this.digitaloffers, this.searchoptions).then(
                (results) => {
                    this.searchresults = results;
                }
            );
        },

        /**
         * Fetches the necessary data for the page.
         */
        fetchData() {
            this.firstLoad = true;


            getDigitalOffers()
                .then((res) => {
                    this.alldigitaloffers = res;
                    this.searchresults = res;
                    this.categoryDescription = this.startpage.describtion;
                    console.log(this.searchresults);

                    const unique_categories = new Set();
                    unique_categories.add("Alle")
                    this.alldigitaloffers.forEach(element => {
                        if(element["category"] != ""){
                            unique_categories.add(element["category"]);
                        }else{
                            unique_categories.add("Ohne Kategorie");
                            element["category"] = "Ohne Kategorie";
                        }
                    });
        
                    this.categories = Array.from(unique_categories);
                })
                .catch((err) => {
                    //console.log(err);
                }).finally(() => {
                    setTimeout(() => {
                        this.firstLoad = false;
                    }, 300);
                });;

        },

        /**
         * Sets a placeholder image in the element.
         * @param {*} e  - The element where the placeholder image is to be set.
         */
        setAltImg(e) {
            e.target.src = require("../../../../assets/tech-placeholder.png");
        },



        getDigitalOffersByCategory(){
            let filteredOffers = [];

            if(this.input.catKey == "Alle"){
                this.digitaloffers = this.alldigitaloffers;
                this.searchresults = this.alldigitaloffers;
            }else{
                this.alldigitaloffers.forEach(element => {
                    if(element["category"] == this.input.catKey){
                        filteredOffers.push(element);
                    }
                });
                this.digitaloffers = filteredOffers;
                this.searchresults = filteredOffers;
            }

            

        }

        /**
         * Retrieves the technology by category.
         * (This feature is new).
         */
        // getTechnologybyCategory() {
        //     this.firstLoad = true;
        //     if (this.input.catKey == "get-all") {
        //         axios
        //             .get(this.requestUrl)
        //             .then((response) => {
        //                 this.technologies = response.data;
        //                 this.searchresults = response.data;
        //                 this.categoryDescription = this.startpage.describtion;
        //                 this.categoryName = "Allgemein";
        //                 // Get Random Projects and BMAs
        //                 const shuffledBmas = this.allBmas.sort(() => 0.5 - Math.random());
        //                 this.bricks = shuffledBmas.slice(0, 3);
        //                 const shuffledBricks = this.allProjects.sort(
        //                     () => 0.5 - Math.random()
        //                 );
        //                 this.projects = shuffledBricks.slice(0, 3);
        //             })
        //             .finally(() => {
        //                 setTimeout(() => {
        //                     this.firstLoad = false;
        //                 }, 300);
        //             });
        //     } else {
        //         axios
        //             .get(this.requestUrl + "get/" + this.input.catKey)
        //             .then((response) => {
        //                 this.fullRequest = response.data;
        //                 this.technologies = response.data.techs;
        //                 this.searchresults = response.data.techs;
        //                 this.categoryName = response.data.category;
        //                 this.categoryDescription = response.data.description;
        //                 this.projects = response.data.pros;
        //                 this.bricks = response.data.bmbs;
        //             })
        //             .finally(() => {
        //                 setTimeout(() => {
        //                     this.firstLoad = false;
        //                 }, 300);
        //             });
        //     }
        // },
    },

    /**
     * Called after the instance has been created.
     */
    created() {
        this.fetchData();
    },

    /**
     * Expressions to watch.
     */
    watch: {
        searchterm: function () {
            if (this.searchterm != "") {
                this.search();
            } else {
                this.searchresults = this.digitaloffers;
            }
        },
    },
};



// WEBPACK FOOTER //
// ./src/components/search/offersearch/views/offersearchmain.js